module.exports = __webpack_public_path__ + "static/media/facebook-icon.bb15ecd6.svg";